import { render } from "./VerificationStep1.vue?vue&type=template&id=6077faeb&scoped=true"
import script from "./VerificationStep1.vue?vue&type=script&lang=js"
export * from "./VerificationStep1.vue?vue&type=script&lang=js"

import "./VerificationStep1.vue?vue&type=style&index=0&id=6077faeb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6077faeb"

export default script